import React, { useState } from 'react';
import { Grid, GridItem, Heading, Text } from '@chakra-ui/react';
import { GeneratePaymentLinkForm } from './components/GeneratePaymentLinkForm';
import { RecentPaymentLinks } from './components/RecentPaymentLinks';
import { PaymentLinkCreatedView } from './components/PaymentLinkCreatedView';
import { useRecentBroxelLinks } from './hooks/useRecentBroxelLinks';
import { CreatePaymentLinkResponseData } from './models/create-payment-link';

const RECENT_LINKS_SIZE = 3;

interface CreatedLink {
  data: CreatePaymentLinkResponseData;
  branchName: string;
}

const GeneratePaymentLink = () => {
  const { records, loading, error, refetch } = useRecentBroxelLinks(RECENT_LINKS_SIZE);
  const [createdLink, setCreatedLink] = useState<CreatedLink | null>(null);

  // Tras crear una liga, se refresca el bloque de "Últimos Links Generados".
  const refetchRecentLinks = () => refetch();

  const handleLinkCreated = (data: CreatePaymentLinkResponseData, branchName: string) => {
    setCreatedLink({ data, branchName });
    refetchRecentLinks();
  };

  if (createdLink) {
    return (
      <PaymentLinkCreatedView
        data={createdLink.data}
        branchName={createdLink.branchName}
        onCreateAnother={() => setCreatedLink(null)}
      />
    );
  }

  return (
    <>
      <Text color="neutral.600" fontSize="s">Link de Pago</Text>
      <Heading as="h2" fontSize="xl" marginBottom="xl">Link de Pago</Heading>

      <Grid templateColumns={{ base: '1fr', lg: '1fr 1.4fr' }} gap="xl" alignItems="start">
        <GridItem>
          <GeneratePaymentLinkForm onLinkCreated={handleLinkCreated} />
        </GridItem>
        <GridItem>
          <RecentPaymentLinks links={records} loading={loading} error={error} />
        </GridItem>
      </Grid>
    </>
  );
};

export default GeneratePaymentLink;
